import React from "react";
import {
  DialogProps,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  Body1,
  DialogActions,
  DialogTrigger,
  Button,
} from "@fluentui/react-components";

import { FallbackRule } from "@/types/risk-analysis";

export interface DeleteFallbackRuleDialogProps extends Omit<DialogProps, "children"> {
  fallbackRule: FallbackRule;
  onAccept: () => void;
}

export function DeleteFallbackRuleDialog({ fallbackRule, onAccept, ...props }: DeleteFallbackRuleDialogProps) {
  return (
    <Dialog {...props}>
      <DialogSurface
        aria-labelledby={`delete-${fallbackRule.id}-title`}
        aria-describedby={`delete-${fallbackRule.id}-content`}
      >
        <DialogBody>
          <DialogTitle id={`delete-${fallbackRule.id}-title`}>Delete Fallback Rule</DialogTitle>
          <DialogContent id={`delete-${fallbackRule.id}-content`}>
            <Body1>
              {fallbackRule.title ? (
                <>
                  Are you sure you want to delete the fallback rule “<b>{fallbackRule.title}</b>”?
                </>
              ) : (
                "Are you sure you want to delete the selected fallback rule?"
              )}
            </Body1>
            <br />
            <Body1>Once you save this action cannot be undone.</Body1>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Cancel</Button>
            </DialogTrigger>
            <Button appearance="primary" onClick={onAccept}>
              Delete
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
